import { render, staticRenderFns } from "./ChartHistorisUser.vue?vue&type=template&id=afa52a98&scoped=true&"
import script from "./ChartHistorisUser.vue?vue&type=script&lang=js&"
export * from "./ChartHistorisUser.vue?vue&type=script&lang=js&"
import style0 from "./ChartHistorisUser.vue?vue&type=style&index=0&id=afa52a98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa52a98",
  null
  
)

export default component.exports